/**
 * 2019-04-12
 * handan
 * 初始化store
 */

import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducer from "../reducer";

const store = createStore(reducer, applyMiddleware(thunk));

export default store;